import { type SxProps, type Theme } from "@mui/material"
import {
  DataGrid,
  type DataGridProps,
  type GridInitialState,
  type GridValidRowModel,
} from "@mui/x-data-grid"

const DEFAULT_PAGE_SIZE_OPTIONS = [25, 50, 100]

const DEFAULT_INITIAL_STATE: GridInitialState = {
  pagination: { paginationModel: { pageSize: 50 } },
}

const ADMIN_GRID_SX: SxProps<Theme> = {
  border: 0,
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "grey.50",
    borderBottom: "1px solid",
    borderBottomColor: "divider",
    fontSize: "0.875rem",
  },
  "& .MuiDataGrid-cell": {
    borderBottom: "1px solid",
    borderBottomColor: "divider",
    display: "flex",
    alignItems: "center",
    fontSize: "0.875rem",
  },
  "& .MuiDataGrid-row:hover": {
    backgroundColor: "grey.50",
  },
  "& .MuiDataGrid-footerContainer": {
    borderTop: "1px solid",
    borderTopColor: "divider",
    fontSize: "0.875rem",
  },
}

const CLICKABLE_ROW_SX: SxProps<Theme> = {
  "& .MuiDataGrid-row": {
    cursor: "pointer",
  },
}

export function AdminDataGrid<R extends GridValidRowModel>(
  props: DataGridProps<R>,
) {
  const { sx, ...rest } = props
  return (
    <DataGrid<R>
      disableRowSelectionOnClick
      checkboxSelection={false}
      pageSizeOptions={DEFAULT_PAGE_SIZE_OPTIONS}
      initialState={DEFAULT_INITIAL_STATE}
      {...rest}
      sx={[
        ADMIN_GRID_SX,
        ...(rest.onRowClick ? [CLICKABLE_ROW_SX] : []),
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
    />
  )
}
